export function priceUnitLabelMap(price_unit) {
  let label = '台·日'
  switch (price_unit) {
    case '1':
      label = '台·日'
      break;
    case '2':
      label = '卡·时'
      break;
    case '3':
      label = 'T·月'
      break;
    case '4':
      label = '台·月'
      break;
    default:
      label = '台·日'
  }
  return label
}

export function getStatusFormat(value) {
  switch (value) {
    case 0:
      return 'info';
    case 1:
      return 'danger';
    case 2:
      return 'primary';
    case 3:
      return 'warning';
    case 4:
      return 'success';
    case 5:
      return 'success';
    default:
      return 'info';
  }
}

export function formatQuestStatusText(value) {
  const map = {
    0: '用户取消',   // 用户取消
    1: '待销售确认', // 处理中
    2: '待交付',     // 销售已确认
    3: '放弃',       // 已拒绝
    4: '已交付',     // 已交付
    5: '已完成',     // 已完成
  };
  return map[value] || '-';
}
